module.exports = __webpack_public_path__ + "static/media/fota_safe_fw.88448e06.png";